@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import site.shadadman.components.layouts.MarkdownLayout as _site_shadadman_components_layouts_MarkdownLayout
import site.shadadman.components.layouts.PageLayout as _site_shadadman_components_layouts_PageLayout
import site.shadadman.pages.HomePage as _site_shadadman_pages_HomePage
import site.shadadman.pages.ResumePage as _site_shadadman_pages_ResumePage
import site.shadadman.pages.VideosPage as _site_shadadman_pages_VideosPage
import site.shadadman.pages.worklog.SportsGameX.Apr92025SportsGamexFirstSprintPage as _site_shadadman_pages_worklog_SportsGameX_Apr92025SportsGamexFirstSprintPage
import site.shadadman.pages.worklog.SportsGameX.Aug122025SportsGameXMLModelPage as _site_shadadman_pages_worklog_SportsGameX_Aug122025SportsGameXMLModelPage
import site.shadadman.pages.worklog.SportsGameX.Aug172025SportsGameXGoogleSigninPage as _site_shadadman_pages_worklog_SportsGameX_Aug172025SportsGameXGoogleSigninPage
import site.shadadman.pages.worklog.SportsGameX.Jul302025SportsGamexTradingViewChartsPage as _site_shadadman_pages_worklog_SportsGameX_Jul302025SportsGamexTradingViewChartsPage
import site.shadadman.pages.worklog.SportsGameX.Jul32025SportsGamexFirebaseAnalyticsPage as _site_shadadman_pages_worklog_SportsGameX_Jul32025SportsGamexFirebaseAnalyticsPage
import site.shadadman.pages.worklog.SportsGameX.Jun122025SportsGameXKMPIntegrationPage as _site_shadadman_pages_worklog_SportsGameX_Jun122025SportsGameXKMPIntegrationPage
import site.shadadman.pages.worklog.SportsGameX.SportsGameXPage as _site_shadadman_pages_worklog_SportsGameX_SportsGameXPage
import site.shadadman.pages.worklog.StrAIberry.Apr22023StrAIberryCalendarChallengePage as _site_shadadman_pages_worklog_StrAIberry_Apr22023StrAIberryCalendarChallengePage
import site.shadadman.pages.worklog.StrAIberry.Dec152021StraAIberryFirstSprintPage as _site_shadadman_pages_worklog_StrAIberry_Dec152021StraAIberryFirstSprintPage
import site.shadadman.pages.worklog.StrAIberry.Jan102022StrAIberryBaseArchDecisionPage as _site_shadadman_pages_worklog_StrAIberry_Jan102022StrAIberryBaseArchDecisionPage
import site.shadadman.pages.worklog.StrAIberry.Jul162024StrAIberryChangingCameraFocusPage as _site_shadadman_pages_worklog_StrAIberry_Jul162024StrAIberryChangingCameraFocusPage
import site.shadadman.pages.worklog.StrAIberry.Mar82024StrAIberryAdvancedCheckupPage as _site_shadadman_pages_worklog_StrAIberry_Mar82024StrAIberryAdvancedCheckupPage
import site.shadadman.pages.worklog.StrAIberry.March22022StrAIberryAGreatTDDPage as _site_shadadman_pages_worklog_StrAIberry_March22022StrAIberryAGreatTDDPage
import site.shadadman.pages.worklog.StrAIberry.May82022StrAIberryChartChallengesPage as _site_shadadman_pages_worklog_StrAIberry_May82022StrAIberryChartChallengesPage
import site.shadadman.pages.worklog.StrAIberry.Nov22022StrAuberryJawIllustrationChallengePage as _site_shadadman_pages_worklog_StrAIberry_Nov22022StrAuberryJawIllustrationChallengePage
import site.shadadman.pages.worklog.StrAIberry.Sep182022StrAIberryLiveDetectionChallengePage as _site_shadadman_pages_worklog_StrAIberry_Sep182022StrAIberryLiveDetectionChallengePage
import site.shadadman.pages.worklog.StrAIberry.StrAIberryPage as _site_shadadman_pages_worklog_StrAIberry_StrAIberryPage
import site.shadadman.pages.worklog.WorklogPage as _site_shadadman_pages_worklog_WorklogPage
import site.shadadman.pages.worklog.alfatechnology.AlfatechnologyPage as _site_shadadman_pages_worklog_alfatechnology_AlfatechnologyPage
import site.shadadman.pages.worklog.alfatechnology.Jan172015AlfaTechnologyGPSPage as _site_shadadman_pages_worklog_alfatechnology_Jan172015AlfaTechnologyGPSPage
import site.shadadman.pages.worklog.alfatechnology.Oct122014AlfaTechnologyFirstSprintPage as _site_shadadman_pages_worklog_alfatechnology_Oct122014AlfaTechnologyFirstSprintPage
import site.shadadman.pages.worklog.bit24cash.Bit24cashPage as _site_shadadman_pages_worklog_bit24cash_Bit24cashPage
import site.shadadman.pages.worklog.bit24cash.Jan112026Bit24MigratingToKMPPage as _site_shadadman_pages_worklog_bit24cash_Jan112026Bit24MigratingToKMPPage
import site.shadadman.pages.worklog.bit24cash.Mar182026bit24AWarHasBegonPage as _site_shadadman_pages_worklog_bit24cash_Mar182026bit24AWarHasBegonPage
import site.shadadman.pages.worklog.bit24cash.Sept92025Bit24FirstSprintPage as _site_shadadman_pages_worklog_bit24cash_Sept92025Bit24FirstSprintPage
import site.shadadman.pages.worklog.marketmlm.Dec182017MarketMLMPaymentMethodsPage as _site_shadadman_pages_worklog_marketmlm_Dec182017MarketMLMPaymentMethodsPage
import site.shadadman.pages.worklog.marketmlm.Feb192018MarketmlmMigratingToKMPpart2Page as _site_shadadman_pages_worklog_marketmlm_Feb192018MarketmlmMigratingToKMPpart2Page
import site.shadadman.pages.worklog.marketmlm.Jan42018MarketmlmMigratingToKMPpart1Page as _site_shadadman_pages_worklog_marketmlm_Jan42018MarketmlmMigratingToKMPpart1Page
import site.shadadman.pages.worklog.marketmlm.Jul222017MarketmlmOfflineFirstPage as _site_shadadman_pages_worklog_marketmlm_Jul222017MarketmlmOfflineFirstPage
import site.shadadman.pages.worklog.marketmlm.June152017MarketMLMFirstSprintPage as _site_shadadman_pages_worklog_marketmlm_June152017MarketMLMFirstSprintPage
import site.shadadman.pages.worklog.marketmlm.MarketmlmPage as _site_shadadman_pages_worklog_marketmlm_MarketmlmPage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Shad Adman"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "site.shadadman.components.layouts.MarkdownLayout",
            parentLayoutId = "site.shadadman.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                site.shadadman.components.layouts.initMarkdownLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _site_shadadman_components_layouts_MarkdownLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "site.shadadman.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _site_shadadman_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
            layoutId = "site.shadadman.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                site.shadadman.pages.initHomePage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_HomePage()
        }
        ctx.router.register(
            "/resume",
            layoutId = "site.shadadman.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                site.shadadman.pages.initResumePage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_ResumePage()
        }
        ctx.router.register(
            "/videos",
            layoutId = "site.shadadman.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                site.shadadman.pages.initVideosPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_VideosPage()
        }
        ctx.router.register(
            "/worklog/SportsGameX/apr92025-sports-gamex-first-sprint",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.SportsGameX.initApr92025SportsGamexFirstSprintPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_SportsGameX_Apr92025SportsGamexFirstSprintPage()
        }
        ctx.router.register(
            "/worklog/SportsGameX/aug122025-sports-game-xml-model",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.SportsGameX.initAug122025SportsGameXMLModelPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_SportsGameX_Aug122025SportsGameXMLModelPage()
        }
        ctx.router.register(
            "/worklog/SportsGameX/aug172025-sports-game-x-google-signin",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.SportsGameX.initAug172025SportsGameXGoogleSigninPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_SportsGameX_Aug172025SportsGameXGoogleSigninPage()
        }
        ctx.router.register(
            "/worklog/SportsGameX/jul302025-sports-gamex-trading-view-charts",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.SportsGameX.initJul302025SportsGamexTradingViewChartsPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_SportsGameX_Jul302025SportsGamexTradingViewChartsPage()
        }
        ctx.router.register(
            "/worklog/SportsGameX/jul32025-sports-gamex-firebase-analytics",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.SportsGameX.initJul32025SportsGamexFirebaseAnalyticsPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_SportsGameX_Jul32025SportsGamexFirebaseAnalyticsPage()
        }
        ctx.router.register(
            "/worklog/SportsGameX/jun122025-sports-game-xkmp-integration",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.SportsGameX.initJun122025SportsGameXKMPIntegrationPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_SportsGameX_Jun122025SportsGameXKMPIntegrationPage()
        }
        ctx.router.register(
            "/worklog/SportsGameX/sports-game-x",
            layoutId = "site.shadadman.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.SportsGameX.initSportsGameXPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_SportsGameX_SportsGameXPage()
        }
        ctx.router.register(
            "/worklog/StrAIberry/apr22023-str-a-iberry-calendar-challenge",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.StrAIberry.initApr22023StrAIberryCalendarChallengePage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_StrAIberry_Apr22023StrAIberryCalendarChallengePage()
        }
        ctx.router.register(
            "/worklog/StrAIberry/dec152021-stra-a-iberry-first-sprint",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.StrAIberry.initDec152021StraAIberryFirstSprintPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_StrAIberry_Dec152021StraAIberryFirstSprintPage()
        }
        ctx.router.register(
            "/worklog/StrAIberry/jan102022-str-a-iberry-base-arch-decision",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.StrAIberry.initJan102022StrAIberryBaseArchDecisionPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_StrAIberry_Jan102022StrAIberryBaseArchDecisionPage()
        }
        ctx.router.register(
            "/worklog/StrAIberry/jul162024-str-a-iberry-changing-camera-focus",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.StrAIberry.initJul162024StrAIberryChangingCameraFocusPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_StrAIberry_Jul162024StrAIberryChangingCameraFocusPage()
        }
        ctx.router.register(
            "/worklog/StrAIberry/mar82024-str-a-iberry-advanced-checkup",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.StrAIberry.initMar82024StrAIberryAdvancedCheckupPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_StrAIberry_Mar82024StrAIberryAdvancedCheckupPage()
        }
        ctx.router.register(
            "/worklog/StrAIberry/march22022-str-a-iberry-a-great-tdd",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.StrAIberry.initMarch22022StrAIberryAGreatTDDPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_StrAIberry_March22022StrAIberryAGreatTDDPage()
        }
        ctx.router.register(
            "/worklog/StrAIberry/may82022-str-a-iberry-chart-challenges",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.StrAIberry.initMay82022StrAIberryChartChallengesPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_StrAIberry_May82022StrAIberryChartChallengesPage()
        }
        ctx.router.register(
            "/worklog/StrAIberry/nov22022-str-auberry-jaw-illustration-challenge",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.StrAIberry.initNov22022StrAuberryJawIllustrationChallengePage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_StrAIberry_Nov22022StrAuberryJawIllustrationChallengePage()
        }
        ctx.router.register(
            "/worklog/StrAIberry/sep182022-str-a-iberry-live-detection-challenge",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.StrAIberry.initSep182022StrAIberryLiveDetectionChallengePage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_StrAIberry_Sep182022StrAIberryLiveDetectionChallengePage()
        }
        ctx.router.register(
            "/worklog/StrAIberry/str-a-iberry",
            layoutId = "site.shadadman.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.StrAIberry.initStrAIberryPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_StrAIberry_StrAIberryPage()
        }
        ctx.router.register(
            "/worklog/alfatechnology/alfatechnology",
            layoutId = "site.shadadman.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.alfatechnology.initAlfatechnologyPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_alfatechnology_AlfatechnologyPage()
        }
        ctx.router.register(
            "/worklog/alfatechnology/jan172015-alfa-technology-gps",
            layoutId = "site.shadadman.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.alfatechnology.initJan172015AlfaTechnologyGPSPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_alfatechnology_Jan172015AlfaTechnologyGPSPage()
        }
        ctx.router.register(
            "/worklog/alfatechnology/oct122014-alfa-technology-first-sprint",
            layoutId = "site.shadadman.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.alfatechnology.initOct122014AlfaTechnologyFirstSprintPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_alfatechnology_Oct122014AlfaTechnologyFirstSprintPage()
        }
        ctx.router.register(
            "/worklog/bit24cash/bit24cash",
            layoutId = "site.shadadman.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.bit24cash.initBit24cashPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_bit24cash_Bit24cashPage()
        }
        ctx.router.register(
            "/worklog/bit24cash/jan112026-bit24-migrating-to-kmp",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.bit24cash.initJan112026Bit24MigratingToKMPPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_bit24cash_Jan112026Bit24MigratingToKMPPage()
        }
        ctx.router.register(
            "/worklog/bit24cash/mar182026bit24-a-war-has-begon",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.bit24cash.initMar182026bit24AWarHasBegonPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_bit24cash_Mar182026bit24AWarHasBegonPage()
        }
        ctx.router.register(
            "/worklog/bit24cash/sept92025-bit24-first-sprint",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.bit24cash.initSept92025Bit24FirstSprintPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_bit24cash_Sept92025Bit24FirstSprintPage()
        }
        ctx.router.register(
            "/worklog/marketmlm/dec182017-market-mlm-payment-methods",
            layoutId = "site.shadadman.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.marketmlm.initDec182017MarketMLMPaymentMethodsPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_marketmlm_Dec182017MarketMLMPaymentMethodsPage()
        }
        ctx.router.register(
            "/worklog/marketmlm/feb192018-marketmlm-migrating-to-km-ppart2",
            layoutId = "site.shadadman.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.marketmlm.initFeb192018MarketmlmMigratingToKMPpart2Page(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_marketmlm_Feb192018MarketmlmMigratingToKMPpart2Page()
        }
        ctx.router.register(
            "/worklog/marketmlm/jan42018-marketmlm-migrating-to-km-ppart1",
            layoutId = "site.shadadman.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.marketmlm.initJan42018MarketmlmMigratingToKMPpart1Page(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_marketmlm_Jan42018MarketmlmMigratingToKMPpart1Page()
        }
        ctx.router.register(
            "/worklog/marketmlm/jul222017-marketmlm-offline-first",
            layoutId = "site.shadadman.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.marketmlm.initJul222017MarketmlmOfflineFirstPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_marketmlm_Jul222017MarketmlmOfflineFirstPage()
        }
        ctx.router.register(
            "/worklog/marketmlm/june152017-market-mlm-first-sprint",
            layoutId = "site.shadadman.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.marketmlm.initJune152017MarketMLMFirstSprintPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_marketmlm_June152017MarketMLMFirstSprintPage()
        }
        ctx.router.register(
            "/worklog/marketmlm/marketmlm",
            layoutId = "site.shadadman.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.marketmlm.initMarketmlmPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_marketmlm_MarketmlmPage()
        }
        ctx.router.register(
            "/worklog/worklog",
            layoutId = "site.shadadman.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                site.shadadman.pages.worklog.initWorklogPage(ctx)
            },
        ) { pageCtx -> 
            _site_shadadman_pages_worklog_WorklogPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("footer", site.shadadman.components.sections.FooterStyle)
        ctx.theme.registerStyle("nav-header", site.shadadman.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("markdown", site.shadadman.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("title-text", site.shadadman.TitleTextStyle)
        ctx.theme.registerStyle("headline-text", site.shadadman.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", site.shadadman.SubheadlineTextStyle)
        ctx.theme.registerStyle("klio-card", site.shadadman.pages.KlioCardStyle)
        ctx.theme.registerStyle("tech-tag", site.shadadman.pages.TechTagStyle)
        ctx.theme.registerStyle("stat-number", site.shadadman.pages.StatNumberStyle)
        ctx.theme.registerVariant("-circle", site.shadadman.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", site.shadadman.UncoloredButtonVariant
        )
        ctx.theme.registerKeyframes("side-menu-slide-in", site.shadadman.components.sections.SideMenuSlideInAnim)
        ctx.theme.registerKeyframes("spin", site.shadadman.pages.SpinAnimation)
        ctx.theme.registerKeyframes("text-fill-keyframe", site.shadadman.pages.TextFillKeyframe)
        ctx.theme.registerKeyframes("marquee-left", site.shadadman.pages.MarqueeLeftAnimation)
        ctx.theme.registerKeyframes("marquee-right", site.shadadman.pages.MarqueeRightAnimation)
        site.shadadman.initColorMode(ctx)
        site.shadadman.initStyles(ctx)
        site.shadadman.initTheme(ctx)
        site.shadadman.initSiteStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        site.shadadman.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
